import store from "redux-share/store";
import { API, getAccessToken, getApiUrls } from "../services";
import { conditions, hasQuestionMark } from "helpers";
import { ConditionName, IDetailsConfig } from "interfaces";
import { errorLogProvider } from "ui/src/components/modules/video-player-library/players/errorBoundaryFunctions";

export const detailAPI = (id?: number) => {
    const { params } = store.getState().videoData;
    return getApiUrls().apiUrl + (id ? id : params.id);
};

const detailsConfig: IDetailsConfig = {
    url: "",
    maxRetryCount: 0,
    headers: {},
    retryPolicy: [],
    errorCallback: undefined
};

const liveDetailsConfig = (userId?: number) => {
    detailsConfig.url = detailAPI(userId);
    let org: string = window.location.origin;
    org = org.replace("https://", "");
    org = org.replace("http://", "");
    detailsConfig.url += "?from=" + org;
};

const nonLiveDetailsConfig = () => {
    detailsConfig.url = detailAPI();
    detailsConfig.maxRetryCount = 3;
    detailsConfig.retryPolicy = [
        {
            codeAbove: 500,
            codeBelow: null,
            excludeCodes: [],
            includeCodes: [409],
            delay: 1,
            count: 3
        },
        {
            codeAbove: null,
            codeBelow: 404,
            excludeCodes: [403, 402, 401, 400],
            includeCodes: [],
            delay: 10,
            count: 6
        }
    ];
    detailsConfig.errorCallback = (status, message) => {
        if (status !== 404) errorLogProvider({ type: "DETAIL_ERROR", message: message ? JSON.parse(message).message : "" });
    };
    return detailsConfig;
};

const hasIsAuthInParams = () => {
    const { token } = store.getState().videoData;
    if (hasQuestionMark(detailsConfig.url)) detailsConfig.url += `&token=${token}`;
    else detailsConfig.url += `?token=${token}`;
};

const hasHInParams = () => {
    detailsConfig.headers = {
        authorization: `Bearer ${getAccessToken()}`
    };
};

export const handleDetailsConfig = (userId?: number) => {
    if (conditions(ConditionName.isLiveParam)) liveDetailsConfig(userId);
    else nonLiveDetailsConfig();

    if (conditions(ConditionName.isAuth)) hasIsAuthInParams();

    if (conditions(ConditionName.hasHParam)) hasHInParams();

    return detailsConfig;
};
